import { QueryClient } from '@tanstack/react-query';
import getCartView from '../../api/cart/get-cart-view';
import { cartKeys } from './query-keys';

const refetchCart = (queryClient: QueryClient) =>
    queryClient.fetchQuery({ queryKey: cartKeys.view(), queryFn: getCartView });

export default refetchCart;
